import stylesModule from './ModelEditFiles.module.scss';

export const styles = stylesModule;
